import { ReactElement } from "react";
import { Stack } from "../stack/stack";
import { Icon } from "../icon/icon";
import { Text } from "../text/text";

interface Props {
  href: string;
  label: string;
  light?: boolean;
}

export function BackNavigation({ href, label, light }: Props): ReactElement {
  const iconColor = light ? "accent-tinted" : "accent-on-inverse";
  const textColor = light
    ? "neutral-on-surface"
    : "neutral-on-surface-lightest-inverse";

  return (
    <a href={href} referrerPolicy="no-referrer">
      <Stack size={6} line="mobile" align="center">
        <Icon name="navigation-back" size={24} color={iconColor} />
        <Text type="sh2" color={textColor}>
          {label}
        </Text>
      </Stack>
    </a>
  );
}
